/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SyncedInputs */

const cs_enum_synced = /** @type {(inputs: Enum_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizováno`)
};

const en_enum_synced = /** @type {(inputs: Enum_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synced`)
};

/**
* | output |
* | --- |
* | "Synced" |
*
* @param {Enum_SyncedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_synced = /** @type {((inputs?: Enum_SyncedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SyncedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_synced(inputs)
	return cs_enum_synced(inputs)
});